import Vue from "vue";
import VueRouter from "vue-router";
import Main from "../pages/client/Main.vue";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 신청 페이지
        path: "/",
        name: "Main",
        component: Main,
    },
    {
        // 조회 페이지
        path: "/inquiry",
        name: "inquiry",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/client/Inquiry.vue"),
        props: true,
    },
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        name: "console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // AS List
        path: "/console/inquiries",
        name: "console-inquiries",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Inquiry/InquiryList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // AS View
        path: "/console/inquiries/:_inquiry",
        name: "console-inquiry",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Inquiry/InquiryView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 설정
        path: "/console/setting",
        name: "console-setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Setting.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 문자/알림톡 셋업
        path: "/console/messages",
        name: "console-messages",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/messages/MessagesView.vue"),
        props: true,
        scope: ["console"],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    try {
        var route = routes.find((route) => route.name == to.name);

        ////////////////////////////////////////////////////////////////////////
        // 스코프 없이 접근이 가능한 경우 접속허용
        ////////////////////////////////////////////////////////////////////////
        if (route.scope === undefined) next();
        ////////////////////////////////////////////////////////////////////////
        // 스코프가 필요한 경우 검증
        ////////////////////////////////////////////////////////////////////////
        else {
            var accessToken = sessionStorage.getItem("accessToken");
            if (!accessToken) {
                if (to.name == "console") {
                    next();
                    return;
                } else throw new Error("로그인 후 이용가능합니다");
            }

            var payload = JSON.parse(atob(accessToken.split(".")[1]));
            var scope = payload.scope || [];

            if (!scope.find((scope) => route.scope.includes(scope))) {
                throw new Error("접근권한이 없습니다");
            }

            next();
        }
    } catch (error) {
        alert(error.message);
        window.location.href = from.path;
    }
});

export default router;
